import React, { useCallback, useEffect, useRef, useState } from "react";

/* ============ STYLES (self-contained) ============ */
const CSS = `
.hm-page { padding: 4px 0 40px; color: #1f2937; }
.hm-page * { box-sizing: border-box; }
.hm-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; margin-bottom: 18px; flex-wrap: wrap; }
.hm-head h2 { margin: 4px 0; font-size: 24px; display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.hm-head p { margin: 0; color: #6b7280; font-size: 14px; }
.hm-eyebrow { font-size: 11px; letter-spacing: .12em; color: #2563eb; font-weight: 700; }
.hm-btn { border: 1px solid #d1d5db; background: #fff; color: #111827; padding: 9px 16px; border-radius: 8px; cursor: pointer; font-size: 14px; font-weight: 600; }
.hm-btn:hover:not(:disabled) { background: #f3f4f6; }
.hm-btn:disabled { opacity: .55; cursor: not-allowed; }
.hm-btn.primary { background: #2563eb; border-color: #2563eb; color: #fff; }
.hm-btn.primary:hover:not(:disabled) { background: #1d4ed8; }
.hm-btn.danger { color: #b91c1c; border-color: #fecaca; }
.hm-btn.danger:hover:not(:disabled) { background: #fef2f2; }
.hm-btn.sm { padding: 6px 12px; font-size: 13px; }
.hm-link { background: none; border: 0; color: #2563eb; cursor: pointer; font-weight: 600; padding: 0; font-size: 14px; }
.hm-notice { padding: 12px 16px; border-radius: 8px; margin-bottom: 14px; font-size: 14px; }
.hm-notice.success { background: #ecfdf5; color: #065f46; border: 1px solid #a7f3d0; }
.hm-notice.error { background: #fef2f2; color: #991b1b; border: 1px solid #fecaca; }
.hm-notice.info { background: #eff6ff; color: #1e40af; border: 1px solid #bfdbfe; }
.hm-toolbar { display: flex; gap: 10px; margin-bottom: 14px; flex-wrap: wrap; }
.hm-toolbar .hm-input:first-child { flex: 1; min-width: 220px; }
.hm-input { width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 14px; background: #fff; color: #111827; font-family: inherit; }
.hm-input:focus { outline: none; border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37,99,235,.12); }
.hm-toolbar .hm-input { width: auto; }
.hm-state { background: #fff; border: 1px dashed #d1d5db; border-radius: 12px; padding: 40px 20px; text-align: center; color: #6b7280; }
.hm-state.err { color: #b91c1c; border-color: #fecaca; }
.hm-state h3 { margin: 8px 0 4px; color: #111827; }
.hm-empty-icon { font-size: 40px; color: #9ca3af; }
.hm-table-wrap { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; overflow-x: auto; }
.hm-table { width: 100%; border-collapse: collapse; min-width: 900px; }
.hm-table th { text-align: left; font-size: 12px; text-transform: uppercase; letter-spacing: .04em; color: #6b7280; padding: 12px 14px; background: #f9fafb; border-bottom: 1px solid #e5e7eb; }
.hm-table td { padding: 12px 14px; border-bottom: 1px solid #f1f5f9; font-size: 14px; vertical-align: middle; }
.hm-table tr:last-child td { border-bottom: 0; }
.hm-table .r { text-align: right; }
.hm-cell-main { display: flex; align-items: center; gap: 12px; }
.hm-cell-main strong { display: block; }
.hm-cell-main small { color: #6b7280; }
.hm-thumb { width: 56px; height: 44px; object-fit: cover; border-radius: 8px; background: #e5e7eb; }
.hm-noimg { width: 56px; height: 44px; display: grid; place-items: center; background: #f3f4f6; color: #9ca3af; font-size: 10px; border-radius: 8px; }
.hm-actions { display: inline-flex; gap: 6px; flex-wrap: wrap; }
.hm-badge { display: inline-block; padding: 3px 10px; border-radius: 999px; font-size: 12px; font-weight: 700; }
.hm-pager { display: flex; justify-content: center; align-items: center; gap: 14px; margin-top: 16px; font-size: 14px; }
.hm-card { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px; margin-bottom: 16px; }
.hm-card.has-err { border-color: #fca5a5; }
.hm-card h3 { margin: 0 0 14px; font-size: 16px; }
.hm-card h3 small { font-weight: 400; color: #6b7280; font-size: 12px; }
.hm-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(230px, 1fr)); gap: 14px; margin-bottom: 4px; }
.hm-grid2 { display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 16px; margin-bottom: 16px; }
.hm-grid2 .hm-card { margin-bottom: 0; }
.hm-field { margin-bottom: 10px; }
.hm-field label { display: block; font-size: 13px; font-weight: 600; margin-bottom: 6px; color: #374151; }
.hm-field label i { color: #dc2626; font-style: normal; margin-left: 3px; }
.hm-field.has-err .hm-input { border-color: #ef4444; }
.hm-err { display: block; color: #dc2626; font-size: 12px; margin-top: 4px; }
.hm-amen { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 10px; }
.hm-amen label { display: flex; align-items: center; gap: 8px; padding: 10px 12px; border: 1px solid #e5e7eb; border-radius: 8px; cursor: pointer; font-size: 14px; }
.hm-amen label.on { background: #eff6ff; border-color: #2563eb; color: #1d4ed8; }
.hm-drop { display: flex; flex-direction: column; align-items: center; gap: 4px; padding: 26px; border: 2px dashed #cbd5e1; border-radius: 12px; cursor: pointer; color: #475569; background: #f8fafc; text-align: center; margin: 10px 0; }
.hm-drop:hover { border-color: #2563eb; background: #eff6ff; }
.hm-drop.small { padding: 16px; }
.hm-drop span { font-size: 12px; color: #94a3b8; }
.hm-sub { font-size: 13px; color: #6b7280; margin: 8px 0; }
.hm-media-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 12px; margin-top: 10px; }
.hm-media { position: relative; border-radius: 10px; overflow: hidden; border: 1px solid #e5e7eb; background: #f3f4f6; }
.hm-media img, .hm-media video { width: 100%; height: 110px; object-fit: cover; display: block; }
.hm-media button { width: 100%; border: 0; background: #fee2e2; color: #991b1b; padding: 6px; cursor: pointer; font-weight: 600; font-size: 12px; }
.hm-docs { display: flex; flex-wrap: wrap; gap: 8px; }
.hm-doc { display: inline-flex; align-items: center; gap: 8px; padding: 7px 12px; background: #f3f4f6; border-radius: 8px; font-size: 13px; color: #2563eb; text-decoration: none; }
.hm-doc a { color: #2563eb; text-decoration: none; }
.hm-doc button { border: 0; background: none; color: #b91c1c; cursor: pointer; font-size: 16px; line-height: 1; }
.hm-submit-bar { position: sticky; bottom: 0; display: flex; justify-content: flex-end; gap: 10px; padding: 14px 0; background: linear-gradient(to top, #fff 70%, rgba(255,255,255,0)); }
.hm-hero { border-radius: 12px; overflow: hidden; background: #000; max-height: 420px; display: flex; justify-content: center; }
.hm-hero img, .hm-hero video { max-width: 100%; max-height: 420px; object-fit: contain; }
.hm-strip { display: flex; gap: 8px; margin-top: 10px; overflow-x: auto; padding-bottom: 4px; }
.hm-strip button { border: 2px solid transparent; padding: 0; border-radius: 8px; overflow: hidden; cursor: pointer; flex: 0 0 auto; background: none; }
.hm-strip button.on { border-color: #2563eb; }
.hm-strip img, .hm-strip video { width: 90px; height: 64px; object-fit: cover; display: block; }
.hm-row { display: flex; justify-content: space-between; gap: 12px; padding: 9px 0; border-bottom: 1px solid #f1f5f9; font-size: 14px; }
.hm-row:last-child { border-bottom: 0; }
.hm-row span { color: #6b7280; }
.hm-row b { text-align: right; font-weight: 600; }
.hm-desc { white-space: pre-wrap; line-height: 1.6; margin: 0; }
.hm-chips { display: flex; flex-wrap: wrap; gap: 8px; }
.hm-chip { background: #eff6ff; color: #1d4ed8; padding: 6px 12px; border-radius: 999px; font-size: 13px; font-weight: 600; }
/* Import this AFTER HostelManager.css. Adds wizard + room styles. */
.hm-steps { list-style: none; display: flex; gap: 6px; padding: 0; margin: 0 0 18px; overflow-x: auto; }
.hm-steps li { flex: 1 0 auto; }
.hm-steps button { width: 100%; display: flex; align-items: center; gap: 8px; padding: 10px 12px; border: 1px solid #e5e7eb; border-radius: 10px; background: #fff; color: #6b7280; font-size: 13px; font-weight: 600; cursor: pointer; white-space: nowrap; }
.hm-steps button:disabled { cursor: default; }
.hm-steps button span { display: inline-grid; place-items: center; width: 22px; height: 22px; border-radius: 50%; background: #f3f4f6; font-size: 12px; }
.hm-steps li.on button { border-color: #2563eb; color: #1d4ed8; background: #eff6ff; }
.hm-steps li.on button span { background: #2563eb; color: #fff; }
.hm-steps li.done button { color: #065f46; }
.hm-steps li.done button span { background: #d1fae5; color: #065f46; }
.hm-steps button:focus-visible, .hm-btn:focus-visible, .hm-link:focus-visible { outline: 2px solid #2563eb; outline-offset: 2px; }

.hm-confirm { align-items: center; }
.hm-confirm span { font-size: 13px; color: #991b1b; font-weight: 600; }

.hm-badge.hm-active, .hm-badge.hm-available { background: #d1fae5; color: #065f46; }
.hm-badge.hm-inactive, .hm-badge.hm-blocked { background: #e5e7eb; color: #374151; }
.hm-badge.hm-maintenance { background: #fef3c7; color: #92400e; }

.hm-beds { width: 100%; border-collapse: collapse; margin-top: 8px; }
.hm-beds th { text-align: left; font-size: 12px; color: #6b7280; padding: 6px 8px; }
.hm-beds td { padding: 4px 8px; vertical-align: middle; font-size: 14px; }
.hm-beds .hm-input { padding: 7px 9px; }
.hm-bed-scroll { overflow-x: auto; max-height: 420px; overflow-y: auto; border: 1px solid #e5e7eb; border-radius: 10px; }
.hm-inline { display: flex; gap: 10px; align-items: flex-end; flex-wrap: wrap; }
.hm-inline .hm-field { flex: 0 0 200px; margin-bottom: 0; }
.hm-check { display: flex; align-items: center; gap: 8px; font-size: 14px; margin-top: 8px; }
.hm-review-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 16px; }

@media (max-width: 640px) {
  .hm-submit-bar { flex-wrap: wrap; }
  .hm-submit-bar .hm-btn { flex: 1; }
}
`;


/* ============ CONFIG ============ */
// NOTE: your server default port is 7000, so set REACT_APP_API_URL in .env (e.g. https://bmtvendorvendorfinal.onrender.com)
const API_BASE = process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com";
const HOSTELS_API = `${API_BASE}/api/vendor/hostels`;
const ROOMS_API = `${API_BASE}/api/vendor/hostel-rooms`;

const MEDIA_ACCEPT = "image/jpeg,image/png,image/webp,video/mp4,video/webm,video/quicktime";
const MAX_SIZE = 20 * 1024 * 1024;

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("vendorToken") || ""}` });

async function request(url, options = {}) {
  const res = await fetch(url, { ...options, headers: { ...authHeaders(), ...(options.headers || {}) } });
  let data = {};
  try { data = await res.json(); } catch { /* ignore */ }
  if (!res.ok || data.success === false) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
}

const money = (n) => `₹ ${Number(n || 0).toLocaleString("en-IN")}`;
const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-";

/* ============ SMALL PIECES ============ */
function StatusBadge({ status }) {
  return <span className={`hm-badge hm-${String(status || "").toLowerCase()}`}>{status || "-"}</span>;
}

function MediaThumb({ item, className = "" }) {
  if (!item) return <div className={`hm-noimg ${className}`}>No media</div>;
  if (item.resourceType === "video") return <video className={className} src={item.url} muted />;
  return <img className={className} src={item.url} alt={item.originalName || "media"} />;
}

function Row({ k, v }) {
  return (
    <div className="hm-row">
      <span>{k}</span>
      <b>{v === undefined || v === null || v === "" ? "-" : v}</b>
    </div>
  );
}

/* Defined at module level on purpose: components declared inside another component
   get re-created on every keystroke and the input loses focus. */
function Field({ label, name, value, onChange, error, required, ...rest }) {
  return (
    <div className={`hm-field ${error ? "has-err" : ""}`}>
      <label htmlFor={name}>{label}{required && <i>*</i>}</label>
      <input id={name} className="hm-input" value={value} onChange={(e) => onChange(name, e.target.value)} {...rest} />
      {error && <small className="hm-err">{error}</small>}
    </div>
  );
}

function SelectField({ label, name, value, onChange, options, error, disabled }) {
  return (
    <div className={`hm-field ${error ? "has-err" : ""}`}>
      <label htmlFor={name}>{label}</label>
      <select id={name} className="hm-input" value={value} disabled={disabled} onChange={(e) => onChange(name, e.target.value)}>
        {options.map((o) => (typeof o === "string" ? <option key={o}>{o}</option> : <option key={o.value} value={o.value}>{o.label}</option>))}
      </select>
      {error && <small className="hm-err">{error}</small>}
    </div>
  );
}

/* ============ WIZARD ============ */
function Stepper({ steps, current, onJump }) {
  return (
    <ol className="hm-steps">
      {steps.map((s, i) => (
        <li key={s} className={i === current ? "on" : i < current ? "done" : ""}>
          <button type="button" disabled={i > current} onClick={() => onJump(i)}>
            <span>{i < current ? "✓" : i + 1}</span>{s}
          </button>
        </li>
      ))}
    </ol>
  );
}

function WizardBar({ step, last, saving, onBack, onCancel, submitLabel }) {
  return (
    <div className="hm-submit-bar">
      <button type="button" className="hm-btn" onClick={onCancel} disabled={saving}>Cancel</button>
      {step > 0 && <button type="button" className="hm-btn" onClick={onBack} disabled={saving}>Back</button>}
      <button type="submit" className="hm-btn primary" disabled={saving}>
        {saving ? "Saving..." : step < last ? "Next" : submitLabel}
      </button>
    </div>
  );
}

/* Delete buttons confirm inline in the row (no browser popup) */
function RowActions({ id, busyId, confirmId, setConfirmId, onView, onEdit, onDelete }) {
  if (confirmId === id) {
    return (
      <div className="hm-actions hm-confirm">
        <span>Delete this?</span>
        <button className="hm-btn sm danger" disabled={busyId === id} onClick={onDelete}>{busyId === id ? "..." : "Yes, delete"}</button>
        <button className="hm-btn sm" onClick={() => setConfirmId("")}>Keep</button>
      </div>
    );
  }
  return (
    <div className="hm-actions">
      <button className="hm-btn sm" onClick={onView}>View</button>
      <button className="hm-btn sm" onClick={onEdit}>Edit</button>
      <button className="hm-btn sm danger" onClick={() => setConfirmId(id)}>Delete</button>
    </div>
  );
}

/* ============ FILE PICKER STATE ============ */
function useFileList(limit, label, flash) {
  const [items, setItems] = useState([]); // {file,url}
  const ref = useRef([]);
  ref.current = items;

  useEffect(() => () => ref.current.forEach((i) => URL.revokeObjectURL(i.url)), []);

  const add = (e, existingCount = 0) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    const ok = [];
    for (const f of files) {
      if (f.size > MAX_SIZE) { flash("error", `${f.name} is larger than 20 MB.`); continue; }
      ok.push({ file: f, url: URL.createObjectURL(f) });
    }
    if (existingCount + items.length + ok.length > limit) {
      ok.forEach((o) => URL.revokeObjectURL(o.url));
      flash("error", `You can add at most ${limit} ${label}.`);
      return;
    }
    setItems((p) => [...p, ...ok]);
  };

  const remove = (idx) => {
    URL.revokeObjectURL(items[idx].url);
    setItems((p) => p.filter((_, i) => i !== idx));
  };

  return { items, add, remove };
}

function useFlash() {
  const [notice, setNotice] = useState(null);
  const timer = useRef();
  const flash = (type, text) => {
    setNotice({ type, text });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setNotice(null), 4000);
  };
  useEffect(() => () => clearTimeout(timer.current), []);
  return [notice, flash];
}

const API = ROOMS_API;


const ROOM_TYPES = ["Dormitory", "Private Room", "Twin Sharing", "Triple Sharing", "Family Room", "Other"];
const GENDERS = ["Unisex", "Male", "Female"];
const BATHROOMS = ["Not Specified", "Attached", "Shared"];
const BED_TYPES = ["Single", "Bunk Upper", "Bunk Lower", "Double"];
const BED_STATUS = ["AVAILABLE", "BLOCKED", "MAINTENANCE"];
const ROOM_AMENITIES = [
  "AC", "Fan", "Attached Bathroom", "Hot Water", "Wi-Fi", "Locker", "Reading Light", "Charging Point",
  "Wardrobe", "Window", "Balcony", "Curtains", "Mattress", "Bed Linen",
];
const MAX_IMAGES = 10;

const STEPS = ["Hostel & basics", "Beds & pricing", "Amenities & photos", "Review"];
const STEP_KEYS = [["hostelId", "roomName", "roomNumber", "roomSize"], ["pricePerBed", "totalBeds", "beds"], [], []];

const EMPTY_FORM = {
  hostelId: "", roomName: "", roomNumber: "", roomType: "Dormitory", genderPreference: "Unisex",
  floor: "", bathroomType: "Not Specified", roomSize: "", description: "",
  pricePerBed: "", totalBeds: "4", amenities: [], isActive: true,
};

const makeBeds = (count, price, existing = []) => {
  const beds = [...existing];
  let k = 1;
  while (beds.length < count) {
    const name = `B${k++}`;
    if (!beds.some((b) => b.bedNumber.toLowerCase() === name.toLowerCase()))
      beds.push({ bedNumber: name, bedType: "Single", pricePerNight: price === "" ? 0 : Number(price), status: "AVAILABLE" });
  }
  return beds.slice(0, count);
};

/* ============ MAIN ============ */
export default function HostelRoomManager() {
  const [view, setView] = useState("list"); // list | add | edit | view
  const [selected, setSelected] = useState(null);
  const [notice, flash] = useFlash();

  const go = (v, room = null) => {
    setSelected(room);
    setView(v);
    window.scrollTo?.({ top: 0 });
  };

  return (
    <div className="hm-page">
      <style>{CSS}</style>
      {notice && <div className={`hm-notice ${notice.type}`} role="status">{notice.text}</div>}

      {view === "list" && <RoomList go={go} flash={flash} />}
      {view === "view" && selected && <RoomView room={selected} go={go} />}
      {(view === "add" || view === "edit") && (
        <RoomForm
          key={selected?._id || "new"}
          room={view === "edit" ? selected : null}
          onCancel={() => go("list")}
          onSaved={(msg) => { flash("success", msg); go("list"); }}
          flash={flash}
        />
      )}
    </div>
  );
}

/* ============ LIST ============ */
function RoomList({ go, flash }) {
  const [rooms, setRooms] = useState([]);
  const [hostels, setHostels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [hostelId, setHostelId] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [busyId, setBusyId] = useState("");
  const [confirmId, setConfirmId] = useState("");

  useEffect(() => {
    request(`${HOSTELS_API}?limit=100`)
      .then((d) => setHostels(d.hostels || []))
      .catch(() => {});
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const qs = new URLSearchParams({ page, limit: 10 });
      if (hostelId) qs.set("hostelId", hostelId);
      if (search) qs.set("search", search);
      const data = await request(`${API}?${qs.toString()}`);
      setRooms(data.rooms || []);
      setTotalPages(data.totalPages || 1);
      setTotal(data.total || 0);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [page, hostelId, search]);

  useEffect(() => { load(); }, [load]);

  const open = async (r, target) => {
    try {
      const data = await request(`${API}/${r.hostelId}/room/${r._id}`);
      go(target, data.room);
    } catch (e) { flash("error", e.message); }
  };

  const remove = async (r) => {
    setBusyId(r._id);
    try {
      await request(`${API}/${r.hostelId}/room/${r._id}`, { method: "DELETE" });
      flash("success", "Room deleted.");
      setConfirmId("");
      if (rooms.length === 1 && page > 1) setPage(page - 1);
      else load();
    } catch (e) { flash("error", e.message); setConfirmId(""); }
    finally { setBusyId(""); }
  };

  const applySearch = (e) => { e.preventDefault(); setPage(1); setSearch(searchInput.trim()); };

  return (
    <>
      <div className="hm-head">
        <div>
          <span className="hm-eyebrow">HOSTEL PARTNER</span>
          <h2>Rooms & Beds</h2>
          <p>Manage rooms and beds of your hostels. Total rooms: {total}</p>
        </div>
        <button className="hm-btn primary" onClick={() => go("add")}>+ Add Room</button>
      </div>

      <form className="hm-toolbar" onSubmit={applySearch}>
        <input className="hm-input" placeholder="Search by room name, number or type" value={searchInput} onChange={(e) => setSearchInput(e.target.value)} />
        <select className="hm-input" value={hostelId} onChange={(e) => { setPage(1); setHostelId(e.target.value); }}>
          <option value="">All hostels</option>
          {hostels.map((h) => <option key={h._id} value={h._id}>{h.hostelName}</option>)}
        </select>
        <button type="submit" className="hm-btn">Search</button>
        <button type="button" className="hm-btn" onClick={load}>Refresh</button>
      </form>

      {loading && <div className="hm-state">Loading rooms...</div>}
      {!loading && error && <div className="hm-state err">{error} <button className="hm-btn" onClick={load}>Retry</button></div>}

      {!loading && !error && rooms.length === 0 && (
        <div className="hm-state">
          <div className="hm-empty-icon">▭</div>
          <h3>No rooms found</h3>
          <p>Add a hostel first, then add its rooms here.</p>
          <button className="hm-btn primary" onClick={() => go("add")}>+ Add Room</button>
        </div>
      )}

      {!loading && !error && rooms.length > 0 && (
        <div className="hm-table-wrap">
          <table className="hm-table">
            <thead>
              <tr>
                <th>Room</th><th>Hostel</th><th>Type</th><th>Beds</th>
                <th>Price / bed</th><th>Status</th><th>Created</th><th className="r">Actions</th>
              </tr>
            </thead>
            <tbody>
              {rooms.map((r) => (
                <tr key={r._id}>
                  <td>
                    <div className="hm-cell-main">
                      <MediaThumb item={r.images?.[0]} className="hm-thumb" />
                      <div>
                        <strong>{r.roomName}</strong>
                        <small>Room {r.roomNumber}{r.floor ? `, floor ${r.floor}` : ""}</small>
                      </div>
                    </div>
                  </td>
                  <td>{r.hostel ? `${r.hostel.hostelName} (${r.hostel.city})` : "-"}</td>
                  <td>{r.roomType} <small>({r.genderPreference})</small></td>
                  <td>{r.beds?.length ?? r.totalBeds}</td>
                  <td>{money(r.pricePerBed)}</td>
                  <td><StatusBadge status={r.isActive ? "Active" : "Inactive"} /></td>
                  <td>{fmtDate(r.createdAt)}</td>
                  <td className="r">
                    <RowActions
                      id={r._id} busyId={busyId} confirmId={confirmId} setConfirmId={setConfirmId}
                      onView={() => open(r, "view")} onEdit={() => open(r, "edit")} onDelete={() => remove(r)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {totalPages > 1 && (
        <div className="hm-pager">
          <button className="hm-btn sm" disabled={page <= 1} onClick={() => setPage(page - 1)}>‹ Prev</button>
          <span>Page {page} / {totalPages}</span>
          <button className="hm-btn sm" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Next ›</button>
        </div>
      )}
    </>
  );
}

/* ============ VIEW ============ */
function RoomView({ room: r, go }) {
  const [active, setActive] = useState(0);
  const media = r.images || [];
  const current = media[active];
  const beds = r.beds || [];

  return (
    <>
      <div className="hm-head">
        <div>
          <button className="hm-link" onClick={() => go("list")}>← Back to rooms</button>
          <h2>{r.roomName} <StatusBadge status={r.isActive ? "Active" : "Inactive"} /></h2>
          <p>Room {r.roomNumber} · {r.hostel ? `${r.hostel.hostelName}, ${r.hostel.city}` : ""}</p>
        </div>
        <button className="hm-btn primary" onClick={() => go("edit", r)}>Edit Room</button>
      </div>

      <div className="hm-card">
        <h3>Photos & videos ({media.length})</h3>
        {media.length === 0 ? <p>No media uploaded.</p> : (
          <>
            <div className="hm-hero">
              {current.resourceType === "video" ? <video src={current.url} controls /> : <img src={current.url} alt={r.roomName} />}
            </div>
            <div className="hm-strip">
              {media.map((m, i) => (
                <button key={m._id || m.publicId} className={i === active ? "on" : ""} onClick={() => setActive(i)}>
                  <MediaThumb item={m} />
                </button>
              ))}
            </div>
          </>
        )}
      </div>

      <div className="hm-grid2">
        <div className="hm-card">
          <h3>Room details</h3>
          <Row k="Room type" v={r.roomType} />
          <Row k="Gender preference" v={r.genderPreference} />
          <Row k="Floor" v={r.floor} />
          <Row k="Bathroom" v={r.bathroomType} />
          <Row k="Room size" v={r.roomSize ? `${r.roomSize} sq ft` : ""} />
          <Row k="Created" v={fmtDate(r.createdAt)} />
          <Row k="Last updated" v={fmtDate(r.updatedAt)} />
        </div>
        <div className="hm-card">
          <h3>Pricing</h3>
          <Row k="Default price per bed" v={money(r.pricePerBed)} />
          <Row k="Total beds" v={beds.length || r.totalBeds} />
          <Row k="Available beds" v={beds.filter((b) => b.status === "AVAILABLE" && b.isActive !== false).length} />
          <h3 style={{ marginTop: 18 }}>Amenities</h3>
          {r.amenities?.length
            ? <div className="hm-chips">{r.amenities.map((a) => <span key={a} className="hm-chip">{a}</span>)}</div>
            : <p>No amenities selected.</p>}
        </div>
      </div>

      {r.description && <div className="hm-card"><h3>Description</h3><p className="hm-desc">{r.description}</p></div>}

      <div className="hm-card">
        <h3>Beds ({beds.length})</h3>
        <div className="hm-bed-scroll">
          <table className="hm-beds">
            <thead><tr><th>Bed</th><th>Type</th><th>Price / night</th><th>Status</th></tr></thead>
            <tbody>
              {beds.map((b) => (
                <tr key={b._id}>
                  <td>{b.bedNumber}</td><td>{b.bedType}</td><td>{money(b.pricePerNight)}</td>
                  <td><StatusBadge status={b.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

/* ============ ADD / EDIT WIZARD ============ */
function RoomForm({ room, onCancel, onSaved, flash }) {
  const isEdit = Boolean(room);

  const [step, setStep] = useState(0);
  const [form, setForm] = useState(() =>
    room
      ? {
          ...EMPTY_FORM,
          ...Object.fromEntries(Object.keys(EMPTY_FORM).map((k) => [k, room[k] ?? EMPTY_FORM[k]])),
          hostelId: room.hostelId,
          totalBeds: String(room.beds?.length || room.totalBeds || 1),
          amenities: room.amenities || [],
        }
      : EMPTY_FORM
  );
  const [beds, setBeds] = useState(() =>
    room?.beds?.length
      ? room.beds.map((b) => ({ _id: b._id, bedNumber: b.bedNumber, bedType: b.bedType, pricePerNight: b.pricePerNight, status: b.status }))
      : makeBeds(4, "")
  );
  const [hostels, setHostels] = useState([]);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [removeImageIds, setRemoveImageIds] = useState([]);
  const images = useFileList(MAX_IMAGES, "photos/videos", flash);

  const existingImages = (room?.images || []).filter((i) => !removeImageIds.includes(i.publicId));

  useEffect(() => {
    if (isEdit) return;
    request(`${HOSTELS_API}?limit=100`)
      .then((d) => setHostels(d.hostels || []))
      .catch((e) => flash("error", e.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const set = (k, v) => {
    setForm((p) => ({ ...p, [k]: v }));
    if (errors[k]) setErrors((p) => ({ ...p, [k]: "" }));
  };

  /* --- beds */
  const setBedCount = (raw) => {
    if (raw === "") return set("totalBeds", "");
    const n = Math.max(1, Math.min(100, parseInt(raw, 10) || 1));
    set("totalBeds", String(n));
    setBeds((prev) => makeBeds(n, form.pricePerBed, prev));
  };
  const updateBed = (i, k, v) => {
    setBeds((p) => p.map((b, idx) => (idx === i ? { ...b, [k]: v } : b)));
    if (errors.beds) setErrors((p) => ({ ...p, beds: "" }));
  };
  const removeBed = (i) => {
    if (beds.length <= 1) return;
    setBeds((p) => p.filter((_, idx) => idx !== i));
    set("totalBeds", String(beds.length - 1));
  };
  const applyPriceToAll = () => {
    if (form.pricePerBed === "" || Number(form.pricePerBed) < 0) return flash("error", "Enter a valid default price first.");
    setBeds((p) => p.map((b) => ({ ...b, pricePerNight: Number(form.pricePerBed) })));
    flash("success", "Price applied to all beds.");
  };
  const toggleAmenity = (a) =>
    set("amenities", form.amenities.includes(a) ? form.amenities.filter((x) => x !== a) : [...form.amenities, a]);

  const validateAll = () => {
    const e = {};
    if (!form.hostelId) e.hostelId = "Select a hostel";
    if (!form.roomName.trim()) e.roomName = "Required";
    if (!form.roomNumber.trim()) e.roomNumber = "Required";
    if (form.roomSize !== "" && (!Number.isFinite(Number(form.roomSize)) || Number(form.roomSize) < 0)) e.roomSize = "Enter a valid size";
    if (form.pricePerBed === "" || !Number.isFinite(Number(form.pricePerBed)) || Number(form.pricePerBed) < 0) e.pricePerBed = "Enter a valid price";
    const n = Number(form.totalBeds);
    if (!Number.isInteger(n) || n < 1 || n > 100) e.totalBeds = "Between 1 and 100";
    const names = beds.map((b) => b.bedNumber.trim().toLowerCase());
    if (beds.some((b) => !b.bedNumber.trim())) e.beds = "Every bed needs a number";
    else if (new Set(names).size !== names.length) e.beds = "Bed numbers must be unique";
    else if (beds.some((b) => b.pricePerNight === "" || Number(b.pricePerNight) < 0)) e.beds = "Every bed needs a valid price";
    else if (!e.totalBeds && beds.length !== n) e.beds = "Bed count does not match total beds";
    return e;
  };

  const submit = async () => {
    setSaving(true);
    try {
      const fd = new FormData();
      ["hostelId", "roomName", "roomNumber", "roomType", "genderPreference", "floor", "bathroomType", "roomSize", "description", "pricePerBed"]
        .forEach((k) => fd.append(k, String(form[k] ?? "").trim()));
      fd.append("totalBeds", String(beds.length));
      fd.append("amenities", JSON.stringify(form.amenities));
      fd.append("isActive", String(form.isActive));
      fd.append("beds", JSON.stringify(beds.map((b) => ({
        ...(b._id ? { _id: b._id } : {}),
        bedNumber: b.bedNumber.trim(), bedType: b.bedType, status: b.status, pricePerNight: Number(b.pricePerNight),
      }))));
      images.items.forEach((i) => fd.append("images", i.file));
      if (isEdit) fd.append("removeImagePublicIds", JSON.stringify(removeImageIds));

      const url = isEdit ? `${API}/${room.hostelId}/room/${room._id}` : API;
      const data = await request(url, { method: isEdit ? "PUT" : "POST", body: fd });
      onSaved(data.message || "Saved.");
    } catch (e) {
      flash("error", e.message);
    } finally {
      setSaving(false);
    }
  };

  const onSubmit = (ev) => {
    ev.preventDefault();
    const all = validateAll();
    const last = STEPS.length - 1;

    if (step < last) {
      const mine = Object.fromEntries(Object.entries(all).filter(([k]) => STEP_KEYS[step].includes(k)));
      if (Object.keys(mine).length) { setErrors(mine); flash("error", "Please fix the highlighted fields."); return; }
      setErrors({});
      setStep(step + 1);
      window.scrollTo?.({ top: 0 });
      return;
    }
    if (Object.keys(all).length) {
      setErrors(all);
      const bad = STEP_KEYS.findIndex((keys) => keys.some((k) => all[k]));
      if (bad >= 0) setStep(bad);
      flash("error", "Some steps have errors. Please fix them.");
      return;
    }
    submit();
  };

  const fp = (name, label, extra = {}) => (
    <Field label={label} name={name} value={form[name]} onChange={set} error={errors[name]} {...extra} />
  );

  const hostelOptions = isEdit
    ? [{ value: form.hostelId, label: room.hostel?.hostelName || "This hostel" }]
    : [{ value: "", label: hostels.length ? "Select a hostel" : "No hostels found. Add a hostel first" }, ...hostels.map((h) => ({ value: h._id, label: `${h.hostelName} (${h.city})` }))];

  return (
    <form onSubmit={onSubmit} noValidate>
      <div className="hm-head">
        <div>
          <button type="button" className="hm-link" onClick={onCancel}>← Back to rooms</button>
          <h2>{isEdit ? `Edit: ${room.roomName}` : "Add new room"}</h2>
          <p>A room belongs to one hostel and contains its beds.</p>
        </div>
      </div>

      <Stepper steps={STEPS} current={step} onJump={setStep} />

      {step === 0 && (
        <div className="hm-card">
          <h3>Hostel & basics</h3>
          <div className="hm-grid">
            <SelectField label="Hostel" name="hostelId" value={form.hostelId} onChange={set} options={hostelOptions} error={errors.hostelId} disabled={isEdit} />
            {fp("roomName", "Room name", { required: true, maxLength: 120, placeholder: "e.g. Mountain View Dorm" })}
            {fp("roomNumber", "Room number", { required: true, maxLength: 30, placeholder: "e.g. 101" })}
            <SelectField label="Room type" name="roomType" value={form.roomType} onChange={set} options={ROOM_TYPES} />
            <SelectField label="Gender preference" name="genderPreference" value={form.genderPreference} onChange={set} options={GENDERS} />
            {fp("floor", "Floor", { placeholder: "e.g. Ground, 1, 2" })}
            <SelectField label="Bathroom" name="bathroomType" value={form.bathroomType} onChange={set} options={BATHROOMS} />
            {fp("roomSize", "Room size (sq ft)", { type: "number", min: "0" })}
          </div>
          <div className="hm-field">
            <label htmlFor="description">Description</label>
            <textarea id="description" className="hm-input" rows={4} maxLength={5000} value={form.description}
              onChange={(e) => set("description", e.target.value)} placeholder="Describe the room" />
          </div>
          {isEdit && (
            <label className="hm-check">
              <input type="checkbox" checked={form.isActive} onChange={(e) => set("isActive", e.target.checked)} />
              Room is active and can be booked
            </label>
          )}
        </div>
      )}

      {step === 1 && (
        <div className={`hm-card ${errors.beds ? "has-err" : ""}`}>
          <h3>Beds & pricing</h3>
          <div className="hm-inline">
            {fp("pricePerBed", "Default price per bed / night (₹)", { type: "number", min: "0", required: true })}
            <div className={`hm-field ${errors.totalBeds ? "has-err" : ""}`}>
              <label htmlFor="totalBeds">Number of beds<i>*</i></label>
              <input id="totalBeds" className="hm-input" type="number" min="1" max="100" value={form.totalBeds} onChange={(e) => setBedCount(e.target.value)} />
              {errors.totalBeds && <small className="hm-err">{errors.totalBeds}</small>}
            </div>
            <button type="button" className="hm-btn" onClick={applyPriceToAll}>Apply default price to all beds</button>
          </div>
          {errors.beds && <small className="hm-err">{errors.beds}</small>}
          {isEdit && <p className="hm-sub">Removing a bed that has an active booking will be blocked when you save.</p>}

          <div className="hm-bed-scroll">
            <table className="hm-beds">
              <thead><tr><th>Bed number</th><th>Type</th><th>Price / night (₹)</th><th>Status</th><th /></tr></thead>
              <tbody>
                {beds.map((b, i) => (
                  <tr key={b._id || i}>
                    <td><input className="hm-input" value={b.bedNumber} onChange={(e) => updateBed(i, "bedNumber", e.target.value)} aria-label={`Bed ${i + 1} number`} /></td>
                    <td>
                      <select className="hm-input" value={b.bedType} onChange={(e) => updateBed(i, "bedType", e.target.value)} aria-label={`Bed ${i + 1} type`}>
                        {BED_TYPES.map((t) => <option key={t}>{t}</option>)}
                      </select>
                    </td>
                    <td><input className="hm-input" type="number" min="0" value={b.pricePerNight} onChange={(e) => updateBed(i, "pricePerNight", e.target.value)} aria-label={`Bed ${i + 1} price`} /></td>
                    <td>
                      <select className="hm-input" value={b.status} onChange={(e) => updateBed(i, "status", e.target.value)} aria-label={`Bed ${i + 1} status`}>
                        {BED_STATUS.map((t) => <option key={t}>{t}</option>)}
                      </select>
                    </td>
                    <td><button type="button" className="hm-btn sm danger" disabled={beds.length <= 1} onClick={() => removeBed(i)}>Remove</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {step === 2 && (
        <>
          <div className="hm-card">
            <h3>Amenities</h3>
            <div className="hm-amen">
              {ROOM_AMENITIES.map((a) => (
                <label key={a} className={form.amenities.includes(a) ? "on" : ""}>
                  <input type="checkbox" checked={form.amenities.includes(a)} onChange={() => toggleAmenity(a)} />
                  {a}
                </label>
              ))}
            </div>
          </div>

          <div className="hm-card">
            <h3>Photos & videos <small>(optional, max {MAX_IMAGES}, up to 20 MB each)</small></h3>

            {isEdit && existingImages.length > 0 && (
              <>
                <p className="hm-sub">Current files</p>
                <div className="hm-media-grid">
                  {existingImages.map((m) => (
                    <div className="hm-media" key={m.publicId}>
                      <MediaThumb item={m} />
                      <button type="button" onClick={() => setRemoveImageIds([...removeImageIds, m.publicId])}>Remove</button>
                    </div>
                  ))}
                </div>
              </>
            )}
            {isEdit && removeImageIds.length > 0 && (
              <p className="hm-sub">{removeImageIds.length} file(s) will be removed. <button type="button" className="hm-link" onClick={() => setRemoveImageIds([])}>Undo</button></p>
            )}

            <label className="hm-drop">
              <input type="file" multiple accept={MEDIA_ACCEPT} hidden onChange={(e) => images.add(e, existingImages.length)} />
              <b>＋ Choose photos / videos</b>
              <span>JPG, PNG, WEBP, MP4, WEBM, MOV</span>
            </label>

            {images.items.length > 0 && (
              <div className="hm-media-grid">
                {images.items.map((m, i) => (
                  <div className="hm-media" key={m.url}>
                    {m.file.type.startsWith("video/") ? <video src={m.url} muted /> : <img src={m.url} alt={m.file.name} />}
                    <button type="button" onClick={() => images.remove(i)}>Remove</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}

      {step === 3 && (
        <div className="hm-review-grid">
          <div className="hm-card">
            <h3>Room</h3>
            <Row k="Hostel" v={hostelOptions.find((o) => o.value === form.hostelId)?.label} />
            <Row k="Name / number" v={`${form.roomName} / ${form.roomNumber}`} />
            <Row k="Type" v={form.roomType} />
            <Row k="Gender" v={form.genderPreference} />
            <Row k="Floor" v={form.floor} />
            <Row k="Bathroom" v={form.bathroomType} />
            <Row k="Size" v={form.roomSize ? `${form.roomSize} sq ft` : ""} />
            <Row k="Amenities" v={form.amenities.join(", ")} />
            <Row k="Photos / videos" v={existingImages.length + images.items.length} />
          </div>
          <div className="hm-card">
            <h3>Beds ({beds.length})</h3>
            <Row k="Default price" v={money(form.pricePerBed)} />
            <div className="hm-bed-scroll">
              <table className="hm-beds">
                <thead><tr><th>Bed</th><th>Type</th><th>Price</th><th>Status</th></tr></thead>
                <tbody>
                  {beds.map((b, i) => (
                    <tr key={b._id || i}><td>{b.bedNumber}</td><td>{b.bedType}</td><td>{money(b.pricePerNight)}</td><td>{b.status}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      <WizardBar
        step={step} last={STEPS.length - 1} saving={saving}
        onBack={() => { setStep(step - 1); window.scrollTo?.({ top: 0 }); }}
        onCancel={onCancel}
        submitLabel={isEdit ? "Save changes" : "Create room"}
      />
    </form>
  );
}